<template>
  <Modal title="无试听权限原因历史" v-model="visible" width="700px" transfer>
    <Table :columns="columns" :data="logList" :loading="loading" no-data-text="暂无记录" border></Table>
    <div slot="footer">
      <Button type="primary" @click="visible=false">关闭</Button>
    </div>
  </Modal>
</template>

<script>
  export default {
    name: 'InvalidListenCauseLogModal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      tchId: {
        type: Number
      }
    },
    data () {
      return {
        visible: this.value,
        loading: false,
        logList: [],
        columns: [
          {title: '填写时间', key: 'gmtCreate', width: 160, align: 'center'},
          {title: '填写人', key: 'creatorName', width: 120, align: 'center'},
          {
            title: '原因',
            key: 'cause',
            render: (h, params) => {
              let cause = params.row.cause
              if (!cause) {
                return h('span', {style: {color: '#bbbec4'}}, '（清空）')
              }
              return h('span', {style: {whiteSpace: 'pre-wrap', wordBreak: 'break-all'}}, cause)
            }
          }
        ]
      }
    },
    methods: {
      loadLogs () {
        let self = this
        self.logList = []
        if (!self.tchId) {
          return
        }
        self.loading = true
        self.$http.get('/tch/invalid-listen-cause-logs?tchId=' + self.tchId).then(function (res) {
          self.loading = false
          if (!res || !res.data) {
            return
          }
          self.logList = res.data
        }).catch(function (e) {
          self.loading = false
          self.$Message.error((e && e.msg) || '加载失败')
        })
      }
    },
    watch: {
      value (val) {
        this.visible = val
      },
      visible (val) {
        if (val) {
          this.loadLogs()
        } else {
          this.$emit('input', false)
          this.$emit('on-close', false)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// InvalidListenCauseLogModal.vue?9d7e46b2